import styled from "styled-components";

export const Section = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  svg,
  img {
    width: 15px;
    height: auto;
    flex-shrink: 0;

    @media (min-width: 1280px) {
      width: 20px;
    }

    @media (min-width: 1536px) {
      width: 25px;
    }
  }
`;

export const Title = styled.h4`
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--color-secondary);
  line-height: 1.3;

  @media (min-width: 1280px) {
    font-size: 1.25rem;
  }

  @media (min-width: 1536px) {
    font-size: 1.5rem;
  }
`;

export const Subtitle = styled.p`
  margin: 0;
  font-size: 0.75rem;
  color: var(--color-secondary);

  @media (min-width: 1280px) {
    font-size: 0.875rem;
  }

  @media (min-width: 1536px) {
    font-size: 1rem;
  }
`;

export const CarouselShell = styled.div<{ $variant: "standard" | "dual" }>`
  width: 100%;
  overflow-x: hidden;
  overflow-y: visible;

  .section-rails-container,
  .react-multi-carousel-list {
    overflow: visible !important;
    padding-bottom: ${({ $variant }) =>
      $variant === "standard" ? "10rem" : "0"};
  }

  .react-multi-carousel-track {
    padding-bottom: 1.5rem;
  }

  .react-multi-carousel-item {
    display: flex;
    overflow: visible;
  }
`;

export const ItemWrapper = styled.div<{ $variant: "standard" | "dual" }>`
  width: 100%;
  height: 100%;
  padding: ${({ $variant }) =>
    $variant === "standard"
      ? "1.25rem 0.375rem 2.5rem"
      : "1.25rem 1rem 2.5rem"};
  box-sizing: border-box;
  overflow: visible;
`;
